import informationSettings from './service';
export default {
   informationSettings
};